module.exports = __webpack_public_path__ + "2877ef74ce3f736bec0c9887017a3e24.png";